import Page from "../../components/page/Page";
import KnowledgeBaseEditor from "./KnowledgeBaseEditor";
import "./knowledge-base-page.css";

export default function KnowledgeBasePage() {
    return (
        <Page
            title="Knowledge Base"
            subtitle="Manage the static and semi-static content the AI support layer can rely on."
            className="knowledge-base-page"
        >
            <KnowledgeBaseEditor />
        </Page>
    );
}
